import styles from './financial.module.scss';

/**
 * What a metric section says when it has nothing to report.
 *
 * antd's `Empty` puts a grey illustration inside every one of these, and a
 * revenue screen can easily show four at once — four pictures of an empty box
 * where four sentences would do.
 */
export const MetricsEmpty = ({
  children = 'Nothing recorded for this period',
}) => <div className={styles.emptyState}>{children}</div>;
